import { resetClinicStateAction } from './clinicSlice'
import { resetGeneralDataAction } from './generalDataSlice'
import { resetNotificationStateAction } from './notificationSlice'
import { resetReceiveStateAction } from './receiveSlice'
import { resetSearchQueryStateAction } from './searchQuerySlice'
import { resetServiceStateAction } from './serviceSlice'
import { useDispatch } from 'react-redux'

const useResetStore = () => {
  const dispatch = useDispatch()

  const resetStore = () => {
    dispatch(resetNotificationStateAction())
    dispatch(resetServiceStateAction())
    dispatch(resetSearchQueryStateAction())
    dispatch(resetReceiveStateAction())
    dispatch(resetGeneralDataAction())
    dispatch(resetClinicStateAction())
  }
  return {
    resetStore
  }
}

export default useResetStore
